export const changeAddress = (str: string, country: string) => {
  if (country === "CH" || country === "AT") {
    return str.replaceAll("SIGA Cover GmbH Deutschland", "SIGA Cover AG");
  }
  return str;
};
